import ContainerOrchestration from './ContainerOrchestration'
import GetSupport from './GetSupport'
import NextSteps from './NextSteps'
import { Scenario } from '../../logic/scenarios/data'
import { createDescriptor, PageDescriptor } from '../types'
import Introduction from './Introduction'
import Architecture from '../../logic/Architecture'
import ArchitectureSummary from './ArchitectureSummary'

export function *createGenericPages(scenario: Scenario): Generator<PageDescriptor> {
    if(scenario.containerOrchestration) {
        yield createDescriptor(ContainerOrchestration, {})        
    }
    yield createDescriptor(GetSupport, {  })
    yield createDescriptor(NextSteps, {  })
}

export function *createIntroPages(scenario: Scenario): Generator<PageDescriptor> {
    const architecture = Architecture.Create(scenario)
    yield createDescriptor(Introduction, {})
    yield createDescriptor(ArchitectureSummary, {architecture})
}